import './vendor/flickity.pkgd.js'
// import './custom/distributor-sorting.js'
import './custom/class-helpers.js'
import './custom/scroll-to-top.js'
import './custom/modal.js'
import './custom/product-carousel.js'
import './custom/hover-image-section.js'
import './custom/nav-dropdowns'
import './custom/mobile-menu'
import './custom/history-slider'
import './custom/industry-hero-tabs'
import './custom/video-slider'
import './custom/search-form'
import './custom/news-filters'
import './custom/custom-video-button'
import './custom/gentex-forms'
import './custom/use-directional'
import './custom/trap-focus'
import './custom/hero-carousel'
import Accordion from './custom/accordion'
import SocialShare from './custom/socialShare-vanilla'
import './custom/class-additions.js'

(() => { 
    document.querySelectorAll('.js--accordion').forEach(el => new Accordion(el));
    document.querySelectorAll('[data-social-share-nav]').forEach(nav => new SocialShare(nav) )
})();


